/**
 * Generic business event names.
 *
 * These are vendor-agnostic — components emit these events without knowing
 * which tracking vendors are listening. Each vendor (Bloomreach, GTM, etc.)
 * subscribes and maps to their own event names/formats.
 */
export const EmitterEvent = {
    /** User views a product (PDP or mini-PDP popup). */
    VIEW_ITEM: 'view_item',
    /** User navigates to a category/lister page. */
    CATEGORY_VIEW: 'view_category',
    /** User adds or removes a product from the basket. */
    CART_UPDATE: 'cart_update',
    /** User clicks a product tile (lister, campaign tile, or recommendation widget). */
    PRODUCT_CLICK: 'product_click',
    /** User clicks a filter/facet value. */
    FACET_CLICK: 'facet_click',
    /** A product line within a completed order (emitted once per product, not once per order). */
    PURCHASE: 'purchase',
    /** User logs out of their account. */
    LOGOUT: 'logout',
};
